import React from "react";
import BasePage from "../../components/layout/BasePage";

export default function ErrorPage() {
  return (
    <BasePage>
      <div>ErrorPage</div>
    </BasePage>
  );
}
